<template>
	<div>
		<div style="margin-top: 15px;">
			<van-cell-group inset>
				<van-cell :title="'被保险人：' + detailInfo.insuredName"
					:value="serviceStatusFilter(detailInfo.serviceStatus)" value-class='right-value' />
				<van-cell :title="'失能等级：' + evaluateLevelFilter(detailInfo.evaluateLevel)" />
				<van-cell :title="'服务时长：' + durationFilter(detailInfo.evaluateLevel)" />
				<van-cell
					:title="'服务周期：' + dateFormat('YYYY-mm-dd', detailInfo.startDate) + '至' + dateFormat('YYYY-mm-dd', detailInfo.endDate)" />
			</van-cell-group>
		</div>
		<div ref="planRef" class="div-margin" :style="{height: planDivHeiht + 'px'}" style="background-color: #fcfcfc;">
			<div class='custom-title'>服务排班</div>
			<div>
				<div v-if="worlPlanList.length == 0">
					<van-empty description="服务班表将于排班完成后提供">
					</van-empty>
				</div>
				<div v-else>
					<van-steps direction="vertical" :active="-1">
						<van-step v-for="(item, index) in worlPlanList" :key="index">
							<template #active-icon>
								<van-badge :content="index + 1" color="#5db37f" />
							</template>
							<template #inactive-icon>
								<van-badge :content="index + 1" color="#5db37f" />
							</template>
							<h3 style="color:#5db37f">{{dateFormat("YYYY-mm-dd", item.schedulingDate)}} |
								{{getWeek(item.schedulingDate)}}
							</h3>
							<div v-for="(itm, idx) in item.voList" :key="idx">
								<div>
									<van-row class="margin-top-5">
										<van-col span="12">{{dateFormat("HH:MM", itm.serviceStart)}} -
											{{dateFormat("HH:MM",itm.serviceEnd)}}
										</van-col>
										<van-col span="12">服务时长：{{itm.serviceDuration}}{{itm.serviceDurationUnit}}
										</van-col>
									</van-row>
									<van-row type="flex" align="center">
										<van-col span="4">
											<img src="../../assets/images/work-img.png"
												style="width: 40px;height: 40px;" />
										</van-col>
										<van-col span="12">
											<span
												style="color: #333333;">{{itm.employeeName}}</span>/{{itm.employeeMobile}}
										</van-col>
									</van-row>
									<div class="space"></div>
								</div>

							</div>
						</van-step>
					</van-steps>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Cell,
		CellGroup,
		Empty,
		Step,
		Steps,
		Badge,
		Col,
		Row
	} from 'vant';

	import {
		getSchedulingInfo
	} from '../../api/api'

	export default {
		data() {
			return {
				weekList: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
				policyNo: '',
				detailInfo: {

				},
				planDivHeiht: 600,
				worlPlanList: []
			}
		},
		created() {
			this.policyNo = this.$route.query.policyNo || '60000190201234512316111';
		},
		mounted() {
			this.planDivHeiht = document.documentElement.clientHeight - this.$refs.planRef.getBoundingClientRect().top -
				10;

			this.getDetail();
		},
		filters: {

		},
		methods: {
			evaluateLevelFilter(t) {
				let v = ''
				if (t == 'MILD') {
					v = '轻度失能';
				} else if (t == 'MODERATE') {
					v = '中度失能';
				} else if (t == 'SEVERE') {
					v = '重度失能';
				}
				if(this.detailInfo.serviceStatus == 'AWAIT_EVALUATE') {
					v = ''
				}
				return v;
			},
			durationFilter(t) {
				let v = ''
				if (t == 'MILD') {
					v = '29小时/月';
				} else if (t == 'MODERATE') {
					v = '24小时/月';
				} else if (t == 'SEVERE') {
					v = '19小时/月';
				}
				return v;
			},
			serviceStatusFilter(t) {
				let name = '';
				if (t == 'AWAIT_EVALUATE') {
					name = '待评估'
				} else if (t == 'AWAIT_ALLOCATING') {
					name = '待排班'
				} else if (t == 'IN_ALLOCATING') {
					name = '已排班'
				} else if (t == 'TERMINATED') {
					name = '已终止'
				}
				return name;
			},
			async getDetail() {
				if (this.policyNo == '') return;

				this.$axios.get('https://api.bigtreedev.com/order/tk/h5/scheduling/info', {
					params: {
						policyNo: this.policyNo
					}
				}).then((response) => {
					console.log(response)
					this.worlPlanList = response.data.data.tkPolicySchedulingH5VO;
					this.detailInfo = response.data.data;
					// delete this.detailInfo.tkPolicySchedulingH5VO;
				}).catch((error) =>
					console.log(error)
				);

			},
			getWeek(d) {
				let date = new Date(d)
				let w = this.weekList[date.getDay()];
				let t = new Date();
				if (date.getFullYear() == t.getFullYear() &&
					date.getMonth() == t.getMonth() &&
					date.getDate() == t.getDate()) {
					w = "今天";
				}
				return w;
			},
			dateFormat(fmt, d) {
				let ret;
				let date = new Date(d)
				const opt = {
					"Y+": date.getFullYear().toString(), // 年
					"m+": (date.getMonth() + 1).toString(), // 月
					"d+": date.getDate().toString(), // 日
					"H+": date.getHours().toString(), // 时
					"M+": date.getMinutes().toString(), // 分
					"S+": date.getSeconds().toString() // 秒
				};
				for (let k in opt) {
					ret = new RegExp("(" + k + ")").exec(fmt);
					if (ret) {
						fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
					}
				}
				return fmt;
			}
		},
		components: {
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Empty.name]: Empty,
			[Step.name]: Step,
			[Steps.name]: Steps,
			[Col.name]: Col,
			[Row.name]: Row,
			[Badge.name]: Badge,
		}
	}
</script>

<style>
	body {
		background-color: #f5f5f5;
	}

	.div-margin {
		margin: 16px;
		border: 1px;
		border-radius: 8px;
	}

	.custom-title {
		color: #6bb889;
		font-size: 16px;
		padding: 10px;
	}

	.right-value {
		color: #6bb889;
	}

	.margin-top-5 {
		margin: 5px 0;
	}

	.space {
		background-color: #f9f9f9;
		height: 10px;
		width: 100%;
	}

	.van-step--vertical {
		padding: 10px 0px 0 0;
	}
</style>
